import { IconLayoutDashboard } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { PageLayout } from "@/components/page-layout";

export function Dashboard() {
	return (
		<PageLayout>
			<PageHeader
				breadcrumbItems={[{ title: "Dashboard", href: "/dashboard" }]}
				title="Dashboard"
				description="Welcome to your dashboard"
				icon={
					<IconLayoutDashboard className="size-6 text-primary" aria-hidden />
				}
			/>
			<p className="text-muted-foreground text-sm">
				Your overview will appear here as we add widgets and shortcuts.
			</p>
		</PageLayout>
	);
}

/* istanbul ignore start -- TanStack Router file route registration */
export const Route = createFileRoute("/_authorized/dashboard")({
	component: Dashboard,
});
/* istanbul ignore end */
